module.exports = __webpack_public_path__ + "img/R_REF.3fa13294.svg";